export default __webpack_public_path__ + "assets/logo_klix_web-2eb6f44aa7dd7ae00c9ea74a20f408f7.png";